import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";

const data = {
    "id": 7,
    "user_id": "9997773332",
    "user_name": "developer",
    "product_name": "New product",
    "product_image": "Images/Product/1764654531450.jpg",
    "mrp_price": 0,
    "sell_price": 0,
    "description": "<p><strong style=\"color: rgb(0, 0, 0);\">Lorem Ipsum</strong><span style=\"color: rgb(0, 0, 0);\">&nbsp;is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unkno",
    "status": null,
    "quantity": 0,
    "unit": "",
    "castlist": "[{\"id\":\"e2c657c0-4f08-4da5-81f9-7e01502e4be0\",\"name\":\"Amitabh Bachan\",\"character\":\"Actor\"},{\"id\":\"644e3e04-d1ac-452b-9811-466466c15474\",\"name\":\"Tasi banu\",\"character\":\"Actress\"},{\"id\":\"6f0302fb-1afe-4e6d-af43-d70568d62ca6\",\"name\":\"Kiran Shukla\",\"character\":\"Director\"},{\"id\":\"c90a1121-deb3-4ba8-ac85-74bb5535a981\",\"name\":\"Hritik Roshan\",\"character\":\"Producer\"},{\"id\":\"1231f4e7-2b9a-4ef8-9f33-91c5f9a45ac2\",\"name\":\"Prince Jha\",\"character\":\"Singer\"},{\"id\":\"ff3b3636-e0a2-4fc9-b2ff-048262e7f6d7\",\"name\":\"Kunal Mestry\",\"character\":\"Director\"}]",
    "createdAt": "2025-12-02T05:06:01.000Z",
    "updatedAt": "2025-12-02T05:51:35.000Z"
}

const CastCrew = ({ url }) => {
    const [data, setData] = useState({})
    const { id } = useParams()

    const fetchData = async () => {
        try {
            const response = await fetch(`https://filmlocation.100billion.in/product/getsingleproduct/${id}`);
            const res = await response.json();
            console.log("PRODUCT:", res);
            setData(res);
        } catch (error) {
            console.error(error);
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // ✅ PARSE CASTLIST SAFELY
    const cast = useMemo(() => {
        if (!data.castlist) return [];
        try {
            return JSON.parse(data.castlist);
        } catch (err) {
            console.error("Invalid castlist JSON:", err);
            return [];
        }
    }, [data]);

    const grouped = useMemo(() => {
        return cast.reduce((acc, item) => {
            if (!acc[item.character]) acc[item.character] = [];
            acc[item.character].push(item);
            return acc;
        }, {});
    }, [cast]);

    return (
        <div className="cstlist-main">

            {/* Header */}
            <div
                className="cstlist-header"
                style={{
                    backgroundImage: `linear-gradient(to right, rgba(0,0,0,0.9), rgba(0,0,0,0.5)), url(${url}/${data.product_image})`,
                }}
            >
                <img
                    src={`https://filmlocation.100billion.in/${data.product_image}`}
                    className="cstlist-poster"
                    alt="poster"
                />

                <div>
                    <h1 className="cstlist-title">{data.product_name}</h1>
                    <div
                        className="description-portfolio"
                        style={{ color: "white" }}
                        dangerouslySetInnerHTML={{
                            __html: `<div style="color:white">${data.description}</div>`
                        }}
                    />

                    <h2 className="cstlist-subtitle">Full Cast & Crew</h2>
                </div>
            </div>

            {/* Jump Links */}
            <div className="cstlist-jump-section">
                <div className="cstlist-jump-label">Jump to</div>
                <div className="cstlist-jump-links">
                    {Object.keys(grouped).map((role, idx) => (
                        <a key={idx} href={`#${role}`} className="cstlist-jump-link">
                            {role}
                        </a>
                    ))}
                </div>
            </div>

            <hr className="cstlist-divider" />

            {/* Cast Sections */}
            <div className="cstlist-body">
                {Object.keys(grouped).map((role, index) => (
                    <div key={index} id={role} className="cstlist-section">
                        <div className="cstlist-section-header">
                            <span className="cstlist-section-line"></span>
                            <h2 className="cstlist-section-title">{role}</h2>
                        </div>

                        <div>
                            {grouped[role].map((person) => (
                                <div key={person.id} className="cstlist-card">
                                    <span className="cstlist-name">{person.name}</span>
                                    <span className="cstlist-role">{person.character}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>

        </div>
    );
};

export default CastCrew;
